import React, { useState } from 'react';
import './App.css';
import Menu from './components/Menu';
import { Container, Row, Col, Navbar, NavbarToggler, NavbarBrand, Button } from 'reactstrap';
import helpers from "./helpers/Utilities";

function Inicio() {

    const [menu, setMenu] = useState(false);
    const toggleMenu = () => { setMenu(!menu); };

    const nome = JSON.parse(localStorage.getItem('usuario_logado')).nome;
    const validade = helpers.formatDateBR(JSON.parse(localStorage.getItem('usuario_logado')).validade);

    return (
        <div id="wrapper" className={`d-flex ${menu ? 'toggled' : ''}`}>
            <Menu />
            <div id="page-content-wrapper">
                <Navbar className="bg-azul" dark>
                    <NavbarToggler onClick={toggleMenu} className="mr-2 border-0" />
                    <NavbarBrand className='mr-auto'>Anuidade</NavbarBrand>
                </Navbar>
                <Container>
                    <Row>
                        <Col className="pt-3">
                            <p><span className="txt-azul font-weight-bold">Nome:</span><br/>{nome}</p>
                            <p><span className="txt-azul font-weight-bold">Validade:</span><br/>{validade}</p>
                            <p className="txt-azul small text-center">Sua anuidade está <b>vigente</b>. Você pode prorrogá-la a qualquer momento, fazendo uma renovação por mais 12 meses.</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="text-center pt-4">
                            <Button onClick={() => helpers.externalLink('https://pag.ae/7Ydtp7Jr1')} className="btn btn-lg btn-block btn-primary btn-azul">Renovar Agora</Button>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
}

export default Inicio;
